import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";

import { Message, Segment } from "semantic-ui-react";

import { MailToMessage } from "./components";

export function Layout({ children, errorMessage, infoMessage }) {
  return (
    <div
      style={{
        position: "absolute",
        minWidth: "100%",
        minHeight: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Segment style={{ width: "525px", padding: "40px" }}>
        <img
          alt="Hubly"
          src="/images/hubly.png"
          style={{
            margin: "auto",
            display: "block",
            width: "149px",
            paddingBottom: "50px",
          }}
        />
        <Message
          data-test="error-message-container"
          negative
          hidden={!errorMessage}
        >
          <Message.Header>Error</Message.Header>
          <p>
            <MailToMessage subject={get(errorMessage, "subject")}>
              {get(errorMessage, "message") || errorMessage}
            </MailToMessage>
          </p>
        </Message>
        <div data-test="info-message-container">{infoMessage}</div>
        <div style={{ paddingTop: "0.5em" }}>{children}</div>
      </Segment>
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node,
  infoMessage: PropTypes.node,
  errorMessage: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
};
Layout.defaultProps = {
  children: null,
  infoMessage: null,
  errorMessage: null,
};

export default Layout;
